<script lang="ts" setup>
import { OrganismTrackingOrderProps } from "~/components/ProductBlocks/OrganismTrackingOrder.props"

defineProps<OrganismTrackingOrderProps>()
</script>

<template>
  <div
    class="
      tracking-order__content
      flex flex-col
      overflow-hidden
      bg-tiffany-10
      px-2
      py-6
      md:flex-row
      md:space-x-6
      md:[&>*]:flex-1
    "
  >
    <ProductBlocksTrackingOrder v-bind="trackingOrder" />
    <ProductBlocksPurchaseAgain v-bind="lastOrders" />
  </div>
</template>
